import { render, staticRenderFns } from "./ModalSendArchive.vue?vue&type=template&id=18cd839a"
import script from "./ModalSendArchive.vue?vue&type=script&lang=js"
export * from "./ModalSendArchive.vue?vue&type=script&lang=js"
import style0 from "./ModalSendArchive.vue?vue&type=style&index=0&id=18cd839a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports